import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  _setAdmissionMode,
  _setAdmittedToProgramOn,
  _setAlertAptType,
  _setAlertAptTypOth,
  _setAlertAthType,
  _setAlertDate,
  _setAlertDischOthRsn,
  _setAlertEmerCareDate,
  _setAlertUADate,
  _setBehavioralOrTreatmentCaseConference,
  _setCbpProgram,
  _setCbpContact,
  _setComment,
  _setDichargedFromProgramOn,
  _setDischargeMode,
  _setDischargeReason,
  _setEmergencyMedicalCareAt,
  _setMissedAppointmentOn,
  _setUrinalysisFor,
} from './stsAlertAction';
import initialState from './stsAlertInitialState';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getStaAlertForm = createAsyncThunk(
  'stop/getStaAlertForm',
  async (params) => {
    const { stsTabUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(stsTabUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const stsAlertFormSlice = createSlice({
  name: 'stop/stsAlertForm',
  initialState,
  reducers: {
    newStsAlert: (state, action) => action.payload,
    setAlertDate: _setAlertDate,
    setCbpProgram: _setCbpProgram,
    setCbpContact: _setCbpContact,
    setDischargeReason: _setDischargeReason,
    setAlertDischOthRsn: _setAlertDischOthRsn,
    setAlertAptType: _setAlertAptType,
    setMissedAppointmentOn: _setMissedAppointmentOn,
    setAlertAptTypOth: _setAlertAptTypOth,
    setAdmissionMode: _setAdmissionMode,
    setAdmittedToProgramOn: _setAdmittedToProgramOn,
    setAlertAthType: _setAlertAthType,
    setDischargeMode: _setDischargeMode,
    setDichargedFromProgramOn: _setDichargedFromProgramOn,
    setUrinalysisFor: _setUrinalysisFor,
    setAlertUADate: _setAlertUADate,
    setEmergencyMedicalCareAt: _setEmergencyMedicalCareAt,
    setAlertEmerCareDate: _setAlertEmerCareDate,
    setBehavioralOrTreatmentCaseConference: _setBehavioralOrTreatmentCaseConference,
    setComment: _setComment
    //resetStsAlertForm: ()=> null,
  },
  extraReducers: {
    [getStaAlertForm.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  newStsAlert,
  setAlertDate,
  setCbpProgram,
  setCbpContact,
  setDischargeReason,
  setAlertDischOthRsn,
  setAlertAptType,
  setMissedAppointmentOn,
  setAlertAptTypOth,
  setAdmissionMode,
  setAdmittedToProgramOn,
  setAlertAthType,
  setDischargeMode,
  setDichargedFromProgramOn,
  setUrinalysisFor,
  setAlertUADate,
  setEmergencyMedicalCareAt,
  setAlertEmerCareDate,
  setBehavioralOrTreatmentCaseConference,
  setComment,
  //resetStsAlertForm
} = stsAlertFormSlice.actions;

export default stsAlertFormSlice.reducer;
